<template>
    <div id="editor-mask" class="window-scale">
        <div v-for="(item, index) in colorOptions" :key="index" :selectedColor="item.value"
            :style="{ backgroundColor: item.key }" @click="chooseBackgroundColor"></div>
    </div>
</template>

<script>
import PromptDialog from '../dialogs/PromptDialog.vue';

export default {
    name: "WhiteBoardPalette",
    props: [
        "colorOptions",
        "chooseBackgroundColor"
    ],
    data: function () {
        return {
            show: false,
            maxLength: 30,
            promptMessage: "",
            inputTitle: "名稱：",
            placeholder: "請輸入白板名稱",
            confirmTxt: "確定",
            cancelTxt: "取消",
        };
    },
    components: {
        PromptDialog,
    },
    watch: {
        promptMessage: function (newValue) {
            let arr = newValue.match(/[^\x00-\xff]/ig);
            let length = arr == null ? newValue.length : newValue.length + arr.length;

            if (length > this.maxLength) {
                this.promptMessage = newValue.slice(0, -1);
            }
        }
    },
    methods: {
        chooseBackgroundColor(e) {
            this.$emit("chooseBackgroundColor", e);
            this.$emit("closeEditPage", []);
        }
    }
};
</script>

<style scoped>
#editor-mask {
    position: absolute;
    display: flex;
    flex-wrap: wrap;
    transform: translate(-40%, -100%);
    left: 1134px;
    top: 862px;
    background-color: rgb(255, 255, 255);
    width: 415px;
    height: 205px;
    border: 5px;
    border-style: solid;
    border-color: rgb(8, 80, 168);
    padding: 10px;
    gap: 5px;
    z-index: var(--z-index-white-board-editor);
}

#editor-mask div {
    width: 100px;
    height: 100px;
}
</style>